import React from 'react';
import PropTypes from 'prop-types';

import withCollegeService from '../withCollegeService';
import SearchColleges from './components/searchColleges';

const extraProps = {
  cyId: 'Premium-Hem-dualAdmissionsPrograms-Container',
  introMessage: 'dualAdmissionsProgramsIntro',
  placeholderMessage: 'dualAdmissionsProgramsPlaceholder',
};

const InstitutionsSearch = withCollegeService(
  SearchColleges,
  'transferInfo.dualAdmissionsPrograms',
  '',
  {
    value: 'field_he_xfer_dual_admissions',
  },
);

const DualAdmissionsPrograms = ({ formatMessage }) => (
  <InstitutionsSearch
    formatMessage={formatMessage}
    {...extraProps}
  />
);
DualAdmissionsPrograms.propTypes = {
  formatMessage: PropTypes.func,
};

export default DualAdmissionsPrograms;
